import { TApiErrorResponse } from '@sandbox-platform/shared-ui';

import {
  CommissionInvoicePayeeType,
  PendingCommissionDTO,
} from '../../../../types/commission-invoice.types';
import { COMMISSION_INVOICE_PAYEE_TYPE } from '../../../../shared/definitons';
import { ExpertDTO } from '../../../../types/expert.types';
import { OrganizationDTO } from '../../../../types/organization.types';
import { CreateStep } from '../definitions';

export interface PayeeInfo {
  payeeType: CommissionInvoicePayeeType;
  payeeId: string;
  payeeName: string;
}

export interface CommissionInvoiceCreateState {
  step: CreateStep;
  payeeType: CommissionInvoicePayeeType;
  selectedExpert: ExpertDTO | null;
  selectedOrg: OrganizationDTO | null;
  payeeInfo: PayeeInfo | null;
  pendingCommissions: PendingCommissionDTO[];
  selectedKeys: Set<string>;
  loading: boolean;
  error: string | TApiErrorResponse | null;
}

export const initialState: CommissionInvoiceCreateState = {
  step: 1,
  payeeType: COMMISSION_INVOICE_PAYEE_TYPE.ExpertIndividual,
  selectedExpert: null,
  selectedOrg: null,
  payeeInfo: null,
  pendingCommissions: [],
  selectedKeys: new Set(),
  loading: false,
  error: null,
};

/**
 * Returns the unique key for a pending commission
 * @param c - PendingCommissionDTO
 * @returns string
 */
export const commissionKey = (c: PendingCommissionDTO): string =>
  c.commission_id;

/**
 * Returns true if two pending commissions belong to the same invoice group,
 * i.e. they can be included on the same invoice
 * @param a - PendingCommissionDTO
 * @param b - PendingCommissionDTO
 * @returns boolean
 */
export const sameInvoiceGroup = (
  a: PendingCommissionDTO,
  b: PendingCommissionDTO
): boolean =>
  a.invoice_for === b.invoice_for &&
  a.payee_type === b.payee_type &&
  a.payee_expert_id === b.payee_expert_id &&
  a.payee_organization_id === b.payee_organization_id &&
  a.invoice_recipient_type === b.invoice_recipient_type &&
  a.invoice_recipient_expert_id === b.invoice_recipient_expert_id &&
  a.invoice_recipient_organization_id === b.invoice_recipient_organization_id &&
  a.currency === b.currency;

/**
 * Converts an optional date string to an ISO 8601 string
 * @param d - optional date string
 * @returns string | undefined
 */
export const toISO = (d?: string): string | undefined =>
  d ? new Date(d).toISOString() : undefined;
